
import { defineComponent, onMounted, reactive, ref } from 'vue';
import PointInfo from '@/components/organisms/point/PointInfo.vue';
import { usePoint } from '@/compositions/usePoint';
import { PointTransfer } from '@/repositories/pointRepository';
import { datetimeFormat } from '@/utils';
import { StateChanger } from 'vue-infinite-loading';
import { useRouter } from 'vue-router/composables';

export default defineComponent({
  name: 'PagesPointHistory',

  components: {
    PointInfo,
  },

  setup(_) {
    const { getTransfer } = usePoint();
    const { get: getPoint } = usePoint();
    const router = useRouter();

    const state = reactive({
      // for pagination
      from: 0,
      limit: 50, // パフォーマンス次第で調整
    });
    const pointTransfers = ref<PointTransfer[]>([]);
    const currentPointTransfer = ref<PointTransfer | null>(null);
    const currentPoint = ref<number | null>(null);

    const actionType = (
      pointTransfer: PointTransfer
    ): 'grant' | 'exchange' | 'expired' | 'consume' | 'registration_incentive' | null => {
      try {
        return JSON.parse(pointTransfer.purpose).action;
      } catch {
        return null;
      }
    };

    const actionTypeLabel = (pointTransfer: PointTransfer) => {
      const _actionType = actionType(pointTransfer);
      switch (_actionType) {
        case 'grant':
          return '付与';
        case 'exchange':
          return '交換';
        case 'expired':
          return '失効';
        case 'consume':
          return '消費';
        case 'registration_incentive':
          return '登録';
        default:
          return '';
      }
    };

    const tagType = (pointTransfer: PointTransfer) => {
      const _actionType = actionType(pointTransfer);
      switch (_actionType) {
        case 'grant':
          return 'is-success';
        case 'exchange':
          return 'is-purple';
        case 'expired':
          return 'is-danger';
        case 'consume':
          return 'is-primary';
        case 'registration_incentive':
          return '';
        default:
          return '';
      }
    };

    const showHistoryDetail = (transfer: PointTransfer) => {
      currentPointTransfer.value = transfer;
      router.push(`/point_history/${transfer.id}`);
    };

    const infiniteHandler = async ($state: StateChanger) => {
      try {
        // PointTransfer取得
        const { pointTransfers: _pointTransfers } = await getTransfer(state.from, state.limit);
        if (_pointTransfers.length) {
          pointTransfers.value.push(..._pointTransfers);
          state.from += _pointTransfers.length;
          $state.loaded();
        } else {
          $state.complete();
        }
      } catch (e) {
        $state.error();
        throw e;
      }
    };

    const positive = (point: number) => point > 0;

    onMounted(async () => {
      // Point取得
      const { total } = await getPoint();
      currentPoint.value = total;
    });

    return {
      state,
      currentPoint,
      pointTransfers,
      currentPointTransfer,
      actionTypeLabel,
      tagType,
      showHistoryDetail,
      infiniteHandler,
      positive,

      datetimeFormat,
    };
  },
});
